<template>
  <div>
    <section>
      <span
        class="text-weight-bolder"
        style="display: block; font-size: 16px; color: #21324a"
        >Grupos de Produtos</span
      >
      <q-table
        style="max-height: 500px"
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        v-model:pagination="pagination"
        class="tabela-tamanho-fixo my-sticky-header-table"
        dense
        hide-bottom
        row-key="name"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        color="primary"
        @request="handleRequest"
      >
        <template v-slot:top-left>
          <span style="display: block; margin-left: -15px; color: #21324a"
            >Grupos de produtos vinculados ao usuário.</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-grupo_nome="props">
          <q-td style="white-space: normal">
            <div class="row align">
              <span
                @click="
                  getProdutos(props.row.group_id, props.row),
                    (props.row.carregarModal = true)
                "
                style="width: 210px; cursor: pointer; color: #6391f4"
                >{{ props.row.grupo_nome }}</span
              >
            </div>
          </q-td>
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              color="negative"
              icon="sym_o_delete"
              flat
              round
              @click="removerGrupo(props.row.group_id)"
            />
          </q-td>
        </template>

        <template #body-cell-prazo_minimo="props">
          <q-td>
            <span v-if="props.row.prazo_minimo">{{
              props.row.prazo_minimo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </q-td>
        </template>
        <template #body-cell-prazo_maximo="props">
          <q-td>
            <span v-if="props.row.prazo_maximo">{{
              props.row.prazo_maximo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </q-td>
        </template>

        <template #body-cell-ultima_retirada="props">
          <q-td>
            <div class="row">
              <span v-if="props.row.ultima_retirada">{{
                props.row.ultima_retirada
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>

              <span class="q-ml-sm" v-if="props.row.ultima_retirada">{{
                props.row.ultima_retirada.split(" ")[1]
              }}</span>
            </div>
          </q-td>
        </template>

        <template #body-cell-critico="props">
          <q-td>
            <span v-if="props.row.critico == 0"> NÃO </span>
            <span v-else>SIM</span>
          </q-td>
        </template>
      </q-table>
    </section>

    <q-dialog v-model="produtosVizualizar">
      <q-card
        style="
          min-width: 550px;
          max-width: 550px;
          min-height: 648px;
          max-height: 648px;
        "
      >
        <q-card-section>
          <div
            style="
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            class="text-h6"
          >
            <q-tooltip> {{ nomeGrupo }} </q-tooltip>
            {{ "Produtos do Grupo:" + " " + nomeGrupo }}
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section style="height: 500px" class="q-pt-none">
          <q-table
            no-data-label="Nenhum produto encontrado."
            dense
            flat
            table-header-class="bg-accent text-width-bold"
            :rows="rows2"
            :loading="disable2"
            :columns="columns2"
            v-model:pagination="pagination"
            class="q-mt-md tabela-tamanho-fixo my-sticky-header-table"
            row-key="name"
            :rows-per-page-label="'Linhas Por Página'"
            :rows-per-page-options="[0]"
            hide-pagination
            color="primary"
            @request="handleRequest"
          >
            <template #body-cell-remover="props">
              <q-td>
                <q-btn
                  color="negative"
                  icon="sym_o_delete"
                  flat
                  round
                  @click="removerGrupo(props.row.group_id)"
                />
              </q-td>
            </template>

            <template #body-cell-prazo_minimo="props">
              <q-td>
                <span v-if="props.row.prazo_minimo">{{
                  props.row.prazo_minimo
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
              </q-td>
            </template>
            <template #body-cell-prazo_maximo="props">
              <q-td>
                <span v-if="props.row.prazo_maximo">{{
                  props.row.prazo_maximo
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
              </q-td>
            </template>

            <template #body-cell-ultima_retirada="props">
              <q-td>
                <div class="row">
                  <span v-if="props.row.ultima_retirada">{{
                    props.row.ultima_retirada
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}</span>

                  <span class="q-ml-sm" v-if="props.row.ultima_retirada">{{
                    props.row.ultima_retirada.split(" ")[1]
                  }}</span>
                </div>
              </q-td>
            </template>

            <template #body-cell-critico="props">
              <q-td>
                <span v-if="props.row.critico == 0"> NÃO </span>
                <span v-else>SIM</span>
              </q-td>
            </template>
          </q-table>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="close"
            no-caps
            style="border-radius: 8px"
            color="brand-1"
            label="Fechar"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, defineProps } from "vue";
import { useStore } from "vuex";

import { useQuasar } from "quasar";

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);

const columns = [
  {
    name: "grupo_nome",
    label: "Grupo",
    field: "grupo_nome",
    align: "left",
  },
  {
    name: "tipo",
    label: "Tipo Associação",
    field: "tipo",
    align: "left",
  },
  {
    name: "ultima_retirada",
    label: "Ultima Retirada",
    field: "ultima_retirada",
    align: "left",
  },
  {
    name: "quantidade_retirada",
    label: "Já retirou",
    field: "quantidade_retirada",
    align: "left",
  },
  {
    name: "quantidade_total_regra",
    label: "Total da Regra",
    field: "quantidade_total_regra",
    align: "left",
  },
  {
    name: "prazo_minimo",
    label: "Próxima Retirada",
    field: "prazo_minimo",
    align: "left",
  },
  {
    name: "prazo_maximo",
    label: "Prazo Máximo",
    field: "prazo_maximo",
    align: "left",
  },
  {
    name: "critico",
    label: "Crítico?",
    field: "critico",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

const columns2 = [
  {
    name: "codigo",
    label: "Código",
    field: "codigo",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: "descricao",
    align: "left",
  },
];

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 15,
});
const rows = ref([]);
const rows2 = ref([]);
const nomeGrupo = ref("");
const disable = ref(true);
const disable2 = ref(false);
const store = useStore();
const produtosVizualizar = ref(false);
const quasar = useQuasar();
const filtrar = ref("");

const getGrupos = async (page = 0, rowsPerPage = 15) => {
  disable.value = true;
  try {
    let response = await store.dispatch("user/getProdutosGrupos", {
      id: userId.value,
      page,
      search: filtrar.value,
      per_page: rowsPerPage,
    });

    rows.value = response.data.result.data;

    pagination.value.page = response.data.result.current_page;
    pagination.value.rowsPerPage = response.data.result.per_page;
    pagination.value.rowsNumber = response.data.result.total;

    disable.value = false;
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const getProdutos = async (valueId, row) => {
  disable2.value = true;
  try {
    let response = await store.dispatch("user/getProdutos", {
      id: valueId,
    });

    rows2.value = response.data.model.produtos;
    nomeGrupo.value = response.data.model.name;

    disable2.value = false;
    row.carregarModal = false;
    produtosVizualizar.value = true;
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const handleRequest = async (props) => {
  getGrupos(props.pagination.page, props.pagination.rowsPerPage);
};

onMounted(getGrupos);

const removerGrupo = async (group_id) => {
  try {
    await store.dispatch("user/removerGrupo", {
      id: userId.value,
      group_id,
    });

    quasar.notify({
      message: "Grupo removido com sucesoo",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    getGrupos();
  } catch (error) {
    quasar.notify({
      message: "Erro ao remover grupo",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

watch(
  () => filtrar.value,
  () => {
    getGrupos();
  }
);
</script>

<style scoped>
.align {
  align-items: center;
}
</style>

<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  max-height: 500px


  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #EEF3FE

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
